export default {
  ok: "Ok",
  back: "Zurück",
  cancel: "Abbrechen",
  save: "Speichern",
  to_scan: "Zum Scan",
  to_formular: "Direkt zum Formular",
  close: "Schließen",
  generate_token: "Zugriffs-Code generieren",
  to_list: "zur Liste",
  add: "Hinzufügen",
  delete: "Löschen",
  cache: "zwischenspeichern",
  search: "Suchen"
}
